import React from 'react';
import ArrowRight from '@uber/base-icons/arrow-right';
import type { Theme } from 'baseui';
import { ListItemLabel } from 'baseui/list';
import { LabelLarge, ParagraphMedium } from 'baseui/typography';
import removeMarkdown from 'remove-markdown';
import { TRACKING_INCONSISTENCY_SUGGESTION } from './constants';
import { ListItemLabelOverrides, SOPSuggestionSection, SuggestionLabelOverrides, TrackingInconsistencySection } from './styled-components-overrides';
import type { InconsistencyDetailT, SuggestionDetailT } from './types';
import { SUGGESTION_CATEGORY } from './types';
export const REVIEW_SUGGESTIONS_CONFIG = {
  [SUGGESTION_CATEGORY.SPELLING_AND_GRAMMAR]: (error: SuggestionDetailT) => <>
      <ListItemLabel overrides={ListItemLabelOverrides}>
        {removeMarkdown(error.answer.slice(error.suggestion.positionStart, error.suggestion.positionEnd + 1))}
      </ListItemLabel>
      <ListItemLabel>
        <ArrowRight width={20} height={12} />
      </ListItemLabel>
      <ListItemLabel overrides={SuggestionLabelOverrides}>
        {removeMarkdown(error.suggestion.suggestion)}
      </ListItemLabel>
    </>,
  [SUGGESTION_CATEGORY.SOP_RECOMMENDATIONS]: (error: SuggestionDetailT, theme: Theme) => <SOPSuggestionSection>
      <LabelLarge margin={0}>&#8220;{error.answer}&#8221;</LabelLarge>
      <ParagraphMedium margin={0} color={theme.colors.negative}>
        {error.suggestion.suggestion}
      </ParagraphMedium>
    </SOPSuggestionSection>,
  [SUGGESTION_CATEGORY.TRACKING_INCONSISTENCY]: (error: InconsistencyDetailT, theme: Theme) => <TrackingInconsistencySection>
      <LabelLarge margin={0}>
        {error.annotationId}: Frames&nbsp;{error.startIndex + 1}&nbsp;&#8594;&nbsp;
        {error.endIndex + 1}
      </LabelLarge>
      <ParagraphMedium margin={0} color={theme.colors.negative}>
        {error.suggestion || TRACKING_INCONSISTENCY_SUGGESTION}
      </ParagraphMedium>
    </TrackingInconsistencySection>
};